// extracted by mini-css-extract-plugin
export var icon = "ComparisonItem-module--icon--4899b";
export var info = "ComparisonItem-module--info--59362";